import {mapGetters} from "vuex";
import {
    formatHours,
    formatMillisecondsAsHours,
    formatMinutesAsHours,
    formatSecondsAsHours,
    HOUR_FORMATS
} from "@/utils/hourFormat";

export default {
    methods: {
        formatHours(hours, options = {}) {
            return formatHours(hours, {format: this.hourFormat, ...options});
        },
        formatSecondsAsHours(seconds, options = {}) {
            return formatSecondsAsHours(seconds, {format: this.hourFormat, ...options});
        },
        formatMinutesAsHours(minutes, options = {}) {
            return formatMinutesAsHours(minutes, {format: this.hourFormat, ...options});
        },
        formatMillisecondsAsHours(milliseconds, options = {}) {
            return formatMillisecondsAsHours(milliseconds, {format: this.hourFormat, ...options});
        },
        applyHourFormatFromOrganizations(selectedOrganizations, organizationsList = []) {
            const selected = [].concat(selectedOrganizations || []).filter(Boolean);
            this.$store.dispatch('storeHourFormatFromOrganizations',
                selected.map(org => organizationsList.find(o => o.id === org.id) || org));
        },
    },
    computed: {
        ...mapGetters([
            'getHourFormat',
        ]),
        hourFormat() {
            return this.getHourFormat || HOUR_FORMATS.HOURS_MINUTES;
        },
        isDecimalHourFormat() {
            return this.hourFormat === HOUR_FORMATS.DECIMAL;
        }
    },
}
